import { styled, keyframes } from '@mui/material';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

export const Styles = {
  Overlay: styled('div')({
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000
  }),

  Card: styled('div')({
    backgroundColor: '#fff',
    borderRadius: '14px',
    padding: '40px 36px 32px',
    maxWidth: '420px',
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
    animation: `${fadeIn} 0.22s ease`
  }),

  Icon: styled('div')<{ variant: 'success' | 'error' }>(({ variant }) => ({
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    backgroundColor: variant === 'success' ? '#e6f9ee' : '#fdecea',
    color: variant === 'success' ? '#04682E' : '#d32f2f',
    marginBottom: '4px'
  })),

  Title: styled('h2')({
    fontSize: '20px',
    fontWeight: 700,
    margin: 0,
    textAlign: 'center',
    color: '#1a1a1a'
  }),

  Message: styled('p')({
    fontSize: '15px',
    color: '#555',
    textAlign: 'center',
    margin: 0,
    lineHeight: '1.5'
  }),

  Button: styled('button')<{ variant: 'success' | 'error' }>(({ variant }) => ({
    marginTop: '12px',
    padding: '10px 36px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: variant === 'success' ? '#04682E' : '#d32f2f',
    transition: 'opacity 0.15s',
    '&:hover': { opacity: 0.88 }
  }))
};
